<template>
  <el-select
    v-if="customer"
    ref="address"
    filterable
    v-model="selected"
    placeholder="Selecione  uma opção"
    @change="update()"
    @clear="clear()"
  >
    <el-option
      v-for="row of tableData"
      :key="row.id"
      :label="`${row.name ? row.name + ' - ': ''}${row.zipcode} - ${row.address}, ${row.city} (${row.state})`"
      :value="row.id"
    >
      <span style="float: left">{{ `${row.name ? row.name + ' - ': ''}${row.zipcode} - ${row.address}, ${row.city} (${row.state})` }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px">{{
        row.type === 'main'
        ? 'Principal'
        : row.type === 'billet'
          ? 'Fatura'
          : row.type === 'payment'
            ? 'Pagamento'
            : row.type === 'collect'
              ? 'Coleta'
              : 'Outro' 
 }}</span>    
  </el-option>
  </el-select>
  <span v-else>Nenhum cliente selecionado</span>
</template>

<script>
import { CustomerService } from "@/services/customers/customers.services";
export default {
  name: "CustomerAddressList",
  props: ["customer", "current"],
  data: function () {
    return {
      tableData: [],
      selected: "",
    };
  },
  watch: {
    customer: function (v) {
      const vm = this;
      vm.fetch();
    },
  },
  methods: {
    clear() {
      const vm = this;
      vm.$emit("clear");
    },
    fetch() {
      const vm = this;
      vm.tableData = [];
      if (!vm.$props.customer) {
        return false;
      }
      CustomerService.address(vm.$props.customer)
        .then((response) => {
          vm.tableData = response;
          if (vm.$props.current) {
            vm.selected = vm.$props.current;
          }
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        });
    },
    update() {
      const vm = this;
      const addressData = vm.tableData.find(x => x.id == vm.selected);
      vm.$emit("input", vm.selected);
      vm.$emit("selected", addressData);
    },
  },
  mounted() {
    const vm = this;
    vm.fetch();
  },
};
</script>